/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Offerdetail_Badges_Earlyaccess2Inputs */

const id_offerdetail_badges_earlyaccess2 = /** @type {(inputs: Offerdetail_Badges_Earlyaccess2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Akses Awal`)
};

const ms_offerdetail_badges_earlyaccess2 = /** @type {(inputs: Offerdetail_Badges_Earlyaccess2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Akses Awal`)
};

const da_offerdetail_badges_earlyaccess2 = /** @type {(inputs: Offerdetail_Badges_Earlyaccess2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Early Access`)
};

const de_offerdetail_badges_earlyaccess2 = /** @type {(inputs: Offerdetail_Badges_Earlyaccess2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Early Access`)
};

const en_us2_offerdetail_badges_earlyaccess2 = /** @type {(inputs: Offerdetail_Badges_Earlyaccess2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Early Access`)
};

const es_es2_offerdetail_badges_earlyaccess2 = /** @type {(inputs: Offerdetail_Badges_Earlyaccess2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Acceso anticipado`)
};

const es_mx2_offerdetail_badges_earlyaccess2 = /** @type {(inputs: Offerdetail_Badges_Earlyaccess2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Acceso anticipado`)
};

const fil_offerdetail_badges_earlyaccess2 = /** @type {(inputs: Offerdetail_Badges_Earlyaccess2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Early Access`)
};

const fr_offerdetail_badges_earlyaccess2 = /** @type {(inputs: Offerdetail_Badges_Earlyaccess2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Accès anticipé`)
};

const it_offerdetail_badges_earlyaccess2 = /** @type {(inputs: Offerdetail_Badges_Earlyaccess2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Accesso anticipato`)
};

const hu_offerdetail_badges_earlyaccess2 = /** @type {(inputs: Offerdetail_Badges_Earlyaccess2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Korai hozzáférés`)
};

const nl_offerdetail_badges_earlyaccess2 = /** @type {(inputs: Offerdetail_Badges_Earlyaccess2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vroege toegang`)
};

const no_offerdetail_badges_earlyaccess2 = /** @type {(inputs: Offerdetail_Badges_Earlyaccess2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tidlig tilgang`)
};

const pl_offerdetail_badges_earlyaccess2 = /** @type {(inputs: Offerdetail_Badges_Earlyaccess2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wczesny dostęp`)
};

const pt_br2_offerdetail_badges_earlyaccess2 = /** @type {(inputs: Offerdetail_Badges_Earlyaccess2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Acesso antecipado`)
};

const pt_offerdetail_badges_earlyaccess2 = /** @type {(inputs: Offerdetail_Badges_Earlyaccess2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Acesso antecipado`)
};

const ro_offerdetail_badges_earlyaccess2 = /** @type {(inputs: Offerdetail_Badges_Earlyaccess2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Acces timpuriu`)
};

const fi_offerdetail_badges_earlyaccess2 = /** @type {(inputs: Offerdetail_Badges_Earlyaccess2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Early Access`)
};

const sv_offerdetail_badges_earlyaccess2 = /** @type {(inputs: Offerdetail_Badges_Earlyaccess2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Early Access`)
};

const vi_offerdetail_badges_earlyaccess2 = /** @type {(inputs: Offerdetail_Badges_Earlyaccess2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Truy cập sớm`)
};

const tr_offerdetail_badges_earlyaccess2 = /** @type {(inputs: Offerdetail_Badges_Earlyaccess2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erken Erişim`)
};

const cs_offerdetail_badges_earlyaccess2 = /** @type {(inputs: Offerdetail_Badges_Earlyaccess2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Předběžný přístup`)
};

const bg_offerdetail_badges_earlyaccess2 = /** @type {(inputs: Offerdetail_Badges_Earlyaccess2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ранен достъп`)
};

const ru_offerdetail_badges_earlyaccess2 = /** @type {(inputs: Offerdetail_Badges_Earlyaccess2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ранний доступ`)
};

const uk_offerdetail_badges_earlyaccess2 = /** @type {(inputs: Offerdetail_Badges_Earlyaccess2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ранній доступ`)
};

const ar_offerdetail_badges_earlyaccess2 = /** @type {(inputs: Offerdetail_Badges_Earlyaccess2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الوصول المبكر`)
};

const hi_offerdetail_badges_earlyaccess2 = /** @type {(inputs: Offerdetail_Badges_Earlyaccess2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`अर्ली एक्सेस`)
};

const th_offerdetail_badges_earlyaccess2 = /** @type {(inputs: Offerdetail_Badges_Earlyaccess2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`เล่นก่อนใคร`)
};

const ja_offerdetail_badges_earlyaccess2 = /** @type {(inputs: Offerdetail_Badges_Earlyaccess2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`アーリーアクセス`)
};

const zh_cn2_offerdetail_badges_earlyaccess2 = /** @type {(inputs: Offerdetail_Badges_Earlyaccess2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`抢先体验`)
};

const zh_hant1_offerdetail_badges_earlyaccess2 = /** @type {(inputs: Offerdetail_Badges_Earlyaccess2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`搶先體驗`)
};

const ko_offerdetail_badges_earlyaccess2 = /** @type {(inputs: Offerdetail_Badges_Earlyaccess2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`얼리 액세스`)
};

/**
* | output |
* | --- |
* | "Early Access" |
*
* @param {Offerdetail_Badges_Earlyaccess2Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const offerdetail_badges_earlyaccess2 = /** @type {((inputs?: Offerdetail_Badges_Earlyaccess2Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Offerdetail_Badges_Earlyaccess2Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_offerdetail_badges_earlyaccess2(inputs)
	if (locale === "ms") return ms_offerdetail_badges_earlyaccess2(inputs)
	if (locale === "da") return da_offerdetail_badges_earlyaccess2(inputs)
	if (locale === "de") return de_offerdetail_badges_earlyaccess2(inputs)
	if (locale === "en-US") return en_us2_offerdetail_badges_earlyaccess2(inputs)
	if (locale === "es-ES") return es_es2_offerdetail_badges_earlyaccess2(inputs)
	if (locale === "es-MX") return es_mx2_offerdetail_badges_earlyaccess2(inputs)
	if (locale === "fil") return fil_offerdetail_badges_earlyaccess2(inputs)
	if (locale === "fr") return fr_offerdetail_badges_earlyaccess2(inputs)
	if (locale === "it") return it_offerdetail_badges_earlyaccess2(inputs)
	if (locale === "hu") return hu_offerdetail_badges_earlyaccess2(inputs)
	if (locale === "nl") return nl_offerdetail_badges_earlyaccess2(inputs)
	if (locale === "no") return no_offerdetail_badges_earlyaccess2(inputs)
	if (locale === "pl") return pl_offerdetail_badges_earlyaccess2(inputs)
	if (locale === "pt-BR") return pt_br2_offerdetail_badges_earlyaccess2(inputs)
	if (locale === "pt") return pt_offerdetail_badges_earlyaccess2(inputs)
	if (locale === "ro") return ro_offerdetail_badges_earlyaccess2(inputs)
	if (locale === "fi") return fi_offerdetail_badges_earlyaccess2(inputs)
	if (locale === "sv") return sv_offerdetail_badges_earlyaccess2(inputs)
	if (locale === "vi") return vi_offerdetail_badges_earlyaccess2(inputs)
	if (locale === "tr") return tr_offerdetail_badges_earlyaccess2(inputs)
	if (locale === "cs") return cs_offerdetail_badges_earlyaccess2(inputs)
	if (locale === "bg") return bg_offerdetail_badges_earlyaccess2(inputs)
	if (locale === "ru") return ru_offerdetail_badges_earlyaccess2(inputs)
	if (locale === "uk") return uk_offerdetail_badges_earlyaccess2(inputs)
	if (locale === "ar") return ar_offerdetail_badges_earlyaccess2(inputs)
	if (locale === "hi") return hi_offerdetail_badges_earlyaccess2(inputs)
	if (locale === "th") return th_offerdetail_badges_earlyaccess2(inputs)
	if (locale === "ja") return ja_offerdetail_badges_earlyaccess2(inputs)
	if (locale === "zh-CN") return zh_cn2_offerdetail_badges_earlyaccess2(inputs)
	if (locale === "zh-Hant") return zh_hant1_offerdetail_badges_earlyaccess2(inputs)
	return ko_offerdetail_badges_earlyaccess2(inputs)
});
export { offerdetail_badges_earlyaccess2 as "offerDetail.badges.earlyAccess" }